import ResumeTable from "./ResumeTable";

export default ResumeTable;